import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { formatTypes } from '@zipari/shared-ds-util-format';
import { FormattingService } from '../../shared/services/formatting.service';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'mp-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss'],
})
export class InboxComponent implements OnInit, OnChanges {
  @Input() config;
  @Input() datagridConfig;
  @Input() data: object[];
  @Input() clearSelectedMessages: boolean;

  @Output() selectionActionClicked = new EventEmitter<object[]>();
  @Output() messageClicked = new EventEmitter<object[]>();

  selectedMessages: object[] = [];
  messages: object[];
  defaultRows: object[];
  isScrollable: boolean;

  formatTypes = formatTypes;

  constructor(private formattingService: FormattingService) {}

  ngOnInit(): void {
    const [config, datagridConfig, data, clearSelectedMessages] =
      checkInputsForText([
        this.config,
        this.datagridConfig,
        this.data,
        this.clearSelectedMessages,
      ]);

    this.config = config;
    this.datagridConfig = datagridConfig;
    this.data = data;
    this.clearSelectedMessages = clearSelectedMessages;

    this.messages = [...this.data];
    this.isScrollable = this.config.isScrollable && this.messages.length > 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.messages = this.data;
    }

    if (changes['clearSelectedMessages']) {
      this.selectedMessages = [];
    }
  }

  formattedDate(message) {
    return this.formattingService.restructureValueBasedOnFormat(
      message['date'],
      { format: formatTypes.INBOX_DATE },
    );
  }

  areAllRowsSelected() {
    return this.messages.every((message) => this.isMessageSelected(message));
  }

  isMessageSelected(message) {
    return this.selectedMessages.includes(message);
  }

  toggleMessage(message) {
    if (!this.isMessageSelected(message)) {
      this.selectedMessages.push(message);
    } else {
      const idx = this.selectedMessages.indexOf(message);

      this.selectedMessages.splice(idx, 1);
    }
  }
}
